import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import { TenantMenuItemsExternalInner, UserReadExternal } from '@askporter/client-grieg-lyric';
import { IconLink, NavbarLink } from '../../utils';
import MenuListItems from './components/MenuListItems';
import ProfileCardAndMenu from './components/ProfileCardAndMenu';
import { getMainItems } from './utils';
interface MobileAccountMenuProps {
  t: (key: string) => string;
  handleSignOut: () => void;
  mainItems: Array<IconLink | NavbarLink>;
  setProfileMenu: (event: null) => void;
  logoComponent: React.ReactNode;
  open: boolean;
  tenantNavButtons: TenantMenuItemsExternalInner[];
  userProfile: Partial<UserReadExternal>;
}
const MobileAccountMenu: React.FC<MobileAccountMenuProps> = ({
  t,
  handleSignOut,
  mainItems,
  setProfileMenu,
  logoComponent,
  open,
  tenantNavButtons,
  userProfile,
}: MobileAccountMenuProps) => {
  const mainNavItems = getMainItems(mainItems);
  return (
    <>
      <Drawer
        open={open}
        onClose={() => setProfileMenu(null)}
        sx={{ '& .MuiDrawer-paper': { boxSizing: 'border-box', width: '340px' } }}
      >
        <List data-testid="menu">
          <ListItem sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box sx={{ height: '48px' }}>{logoComponent}</Box>
            <ListItemIcon sx={{ justifyContent: 'flex-end' }}>
              <CloseIcon onClick={() => setProfileMenu(null)} />
            </ListItemIcon>
          </ListItem>
          <MenuListItems navItems={mainNavItems} t={t} withGap={true} />
        </List>
        <ProfileCardAndMenu
          userProfile={userProfile}
          t={t}
          tenantNavButtons={tenantNavButtons}
          mainItems={mainItems}
          handleSignOut={handleSignOut}
        />
      </Drawer>
    </>
  );
};
export default MobileAccountMenu;
